// Bootstrap Info Popup Logic
// Opens Bootstrap modal when .info-icon is clicked

document.addEventListener('DOMContentLoaded', function () {
  // HTML sanitization function to prevent XSS attacks
  function escapeHtml(str) {
    if (str == null || str === undefined) return '';
    const text = String(str);
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      '/': '&#x2F;'
    };
    return text.replace(/[&<>"'/]/g, (char) => map[char]);
  }

  // Helper to build modal HTML from data object
  function buildModalHtml(data) {
    const title = escapeHtml(data.title || 'Info');
    const bodyParts = [];

    if (data.paragraphs && Array.isArray(data.paragraphs)) {
      data.paragraphs.forEach(p => bodyParts.push(`<p>${escapeHtml(p)}</p>`));
    }

    if (data.heading) {
      bodyParts.push(`<h3 class="m-0 p-0">${escapeHtml(data.heading)}</h3>`);
    }

    if (data.subheading) {
      bodyParts.push(`<p class="d-block mb-2"><small>${escapeHtml(data.subheading)}</small></p>`);
    }

    if (data.ratings && Array.isArray(data.ratings)) {
      // Render each rating as a single row: icon, label, description
      const ratingHtml = data.ratings.map(r => {
        const iconCls = r.icon ? ` ${escapeHtml(r.icon)}` : '';
        const label = escapeHtml(r.label || '');
        const desc = escapeHtml(r.description || '');
        return `<li class="rating-row d-flex align-items-start mb-2" role="listitem">
          <div class="d-flex align-items-center color-indicator">
            <span class="legend-icon big${iconCls}" aria-hidden="true"></span>
            <strong class="rating-label ps-2">${label}</strong>
          </div>
          <div><p class="rating-desc">${desc}</p></div>
        </li>`;
      }).join('\n');
      bodyParts.push(`<ul class="ratings-list ps-0" role="list">${ratingHtml}</ul>`);
    }

    const modalHtml = `
      <div class="modal fade" id="infoModal" tabindex="-1" aria-labelledby="infoModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title fw-semibold fs-5" id="infoModalLabel">${title}</h2>
              <button type="button" class="btn btn-text btn-sm" data-bs-dismiss="modal" aria-label="Close information dialog" aria-pressed="false"><span class="material-symbols-outlined" aria-hidden="true">close</span></button>
            </div>
            <div class="modal-body px-4">
              ${bodyParts.join('\n')}
            </div>
          </div>
        </div>
      </div>
    `;

    return modalHtml;
  }

  // In-memory store for popup data (populated by loadPopupData)
  var popupDataStore = null;

  // Load popup-data.json into memory and provide access by key
  function loadPopupData() {
    const url = 'data/popup-data.json';
    return fetch(url).then(function (resp) {
      if (!resp.ok) throw new Error('Network response was not ok');
      return resp.json();
    }).then(function (json) {
      popupDataStore = json;
    }).catch(function (err) {
      console.warn('Failed to load popup-data.json. Will use fallback defaults. Error:', err);
    });
  }

  // Initialize popup data
  loadPopupData();

  // Store reference to the triggering button for focus restoration
  var lastTriggerButton = null;

  // Attach click event to info-icon and use data-popup-key to choose content
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('info-icon')) return;
    var key = e.target.getAttribute('data-popup-key');

    // Store the button that triggered the modal
    lastTriggerButton = e.target;

    // Set aria-pressed to true when button is clicked (screen reader announces "pressed")
    try {
      e.target.setAttribute('aria-pressed', 'true');
    } catch (err) {
      // Ignore attribute errors
    }

    // Encapsulate display logic so we can call it immediately or after load
    function showNow() {
      var dataToShow = null;

      if (popupDataStore && key && popupDataStore[key]) {
        dataToShow = popupDataStore[key];
      } else if (popupDataStore && !key && popupDataStore.default) {
        dataToShow = popupDataStore.default;
      } else if (!popupDataStore && key) {
        console.warn('Popup data not yet loaded; opening fallback');
      }

      // If no key matched, try top-level object (for backwards compatibility)
      if (!dataToShow && popupDataStore && popupDataStore.title) {
        dataToShow = popupDataStore;
      }

      if (!dataToShow) {
        // final fallback default
        dataToShow = {
          title: 'Condition Info',
          paragraphs: ["The <strong>Condition Score</strong> is a straightforward, health-check grade that reflects the current physical state of our school building and its essential systems."],
          heading: 'Condition Score Rating',
          subheading: "Meaning for Your Child's School:",
          ratings: [
            { icon: 'legend-info', label: '>= 90 - Excellent', description: 'The school building is in superb physical condition.' }
          ]
        };
      }

      // Remove any existing modal and insert new one for this content
      var existing = document.getElementById('infoModal');
      if (existing) existing.remove();
      document.body.insertAdjacentHTML('beforeend', buildModalHtml(dataToShow));

      var infoModalEl = document.getElementById('infoModal');
      if (infoModalEl) {
        var infoModal = new bootstrap.Modal(infoModalEl);
        
        // Get close button and add aria-pressed toggle on click
        var closeBtn = infoModalEl.querySelector('[data-bs-dismiss="modal"]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function() {
            try {
              closeBtn.setAttribute('aria-pressed', 'true');
            } catch (err) {
              // Ignore attribute errors
            }
          });
        }
        
        // Focus management: move focus to modal when shown
        infoModalEl.addEventListener('shown.bs.modal', function () {
          try {
            // Focus the modal dialog for screen reader announcement
            var modalDialog = infoModalEl.querySelector('.modal-dialog');
            if (modalDialog && modalDialog.setAttribute) {
              modalDialog.setAttribute('tabindex', '-1');
              modalDialog.focus();
            }
          } catch (err) {
            // Fallback: focus the modal element itself
            try { infoModalEl.focus(); } catch (e) {}
          }
        });

        // Focus management: return focus to trigger button when closed
        infoModalEl.addEventListener('hidden.bs.modal', function () {
          try {
            // Reset close button aria-pressed
            if (closeBtn) {
              closeBtn.setAttribute('aria-pressed', 'false');
            }
            if (lastTriggerButton && lastTriggerButton.focus) {
              // Reset aria-pressed to false when modal closes
              lastTriggerButton.setAttribute('aria-pressed', 'false');
              lastTriggerButton.focus();
            }
          } catch (err) {
            // Ignore focus errors
          }
        });

        infoModal.show();
      } else {
        console.warn('Info modal element not found after insertion');
      }
    }

    if (popupDataStore) {
      showNow();
    } else {
      // data not yet loaded — load then show (or fallback if load fails)
      loadPopupData().then(showNow).catch(showNow);
    }
  });
});
